import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { formsSelector, isFormDirtySelector, isFormValidatedSelector, } from '@/models/forms/selectors';
import { formsActions } from '@/models/forms';
import { validateForms } from '@/models/forms/validateForms';
import { goNextStep } from '@/models/steps/goNextStep';
import { UserAgreementBlock } from '../UserAgreementBlock';
import { useInsuranceStyles } from '../styles';
import { ContinueButton } from '../ContinueButton';
import { AgreementPersonalBlock } from './AgreementPersonalBlock';
import { Insurer, INSURER_CONTAINER_ID } from './Insurer';
import { Passengers } from './Passenger/Passengers';
import { PASSENGERS_CONTAINER_ID } from './Passenger/Passengers';
export const FormsTab = () => {
    const insuranceClasses = useInsuranceStyles();
    const isFormValidated = useSelector(isFormValidatedSelector);
    const isFormDirty = useSelector(isFormDirtySelector);
    const forms = useSelector(formsSelector);
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(validateForms());
    }, [forms]);
    const routerLocation = useLocation();
    const locationState = routerLocation.state;
    useEffect(() => {
        if ([PASSENGERS_CONTAINER_ID, INSURER_CONTAINER_ID].includes(locationState)) {
            const containerRef = document.getElementById(locationState);
            containerRef?.scrollIntoView({ behavior: 'smooth' });
            routerLocation.state = null;
        }
    }, [locationState]);
    const onContinue = useCallback(() => {
        dispatch(formsActions.setFormDirty());
        if (!isFormValidated) {
            return;
        }
        dispatch(goNextStep());
    }, [isFormValidated]);
    return (_jsxs(_Fragment, { children: [_jsx(Passengers, {}), _jsx(Insurer, {}), _jsx(AgreementPersonalBlock, {}), _jsx("div", { className: insuranceClasses.buttons, children: _jsx(ContinueButton, { onClick: onContinue, isDisabled: isFormDirty && !isFormValidated }) }), _jsx(UserAgreementBlock, {})] }));
};
